<template>
<div class="information-wrapper">
  <!-- 分页导航 -->
  <div class = "pager">
    <el-pagination
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="page.currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="page.totalRecord">
    </el-pagination>
  </div>

  <el-table
    :data="datas"
    style="width: 100%"
    highlight-current-row
    class = "data-table"
    >
    <el-table-column
      label="海报"
      width="180">
      <template slot-scope="scope">
        <el-image
          style="width: 100px; height: 100px"
          :src="scope.row.image_url"
          fit="fill" />
      </template>
    </el-table-column>
    <el-table-column label="标题">
      <template slot-scope="scope">
        <el-link :href="scope.row.content_url" target="_blank">{{scope.row.title}}</el-link>
      </template>
    </el-table-column>

    <el-table-column prop="update_time" label="更新时间"></el-table-column>

    <el-table-column label="收藏">
      <template slot-scope="scope">
        <i :class="{selected : scope.row.is_favorite>0}" class="el-icon-star-on" @click="onFavorite(scope.row)"  />
      </template>
    </el-table-column>

  </el-table>

</div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  data() {
    return {
      datas: [],
      initDatas:[],
      page:{
        pageSize: 10, //每页条数,  默认10条
        totalRecord: 0, //总条数
        totalPage: 0, //总页数
        currentPage:1  //当前显示页码
      }
    };
  },
  computed:{
    ...mapState({
      userinfo: 'userinfo'
    })
  },
  mounted() {
    this.loadData()
  },
  beforeDestroy(){
    this.saveFavorite()
  },
  methods: {
    onFavorite(row){
      row.is_favorite = row.is_favorite==0 ? 1 : 0
      this.saveFavorite()
    },
    saveFavorite(){
      const that = this

      let changedRows = []
      that.datas.forEach((item,index)=>{
        if(that.initDatas[index].is_favorite != item.is_favorite)
          changedRows.push(item)
      })

      if(changedRows.length==0)
        return

      let jsonStr = JSON.stringify(changedRows)
      const params = new FormData()
      params.append('userid', that.userinfo.id)
      params.append('json', jsonStr)

      that.axios.post('/information/savefavorites', params)
      .then((ret)=>{
        let {code,message} = ret
        if(code===0){
          that.initDatas = JSON.parse(JSON.stringify(that.datas))
          that.$message('保存成功')
        }else{
          that.$message('查询失败')
          that.$message(message)
        }
      })
    },
    loadData(){
      const that = this

      let params={
        'currentpage': that.page.currentPage,
        'pagesize': that.page.pageSize,
        'userid': that.userinfo.id
      }
      that.axios.get('/information/listwithpage',{params})
      .then(res =>{
        let {code, data, message} = res;
        if(code===0){
          that.datas = data.list;
          that.initDatas = JSON.parse(JSON.stringify(that.datas))

          that.page.totalRecord = data.total  //总条数
          that.page.totalPage = data.pages    //总页数
        }else{
          that.$message(message);
        }
      });
    },
    // 修改每页记录数
    sizeChange(val) {
      this.page.pageSize = val
      this.saveFavorite()
      this.loadData()
    },
    //翻页
    currentChange(val) {
      this.page.currentPage=val
      this.saveFavorite()
      this.loadData()
    },
  }
}
</script>

<style lang="stylus" scoped>
.information-wrapper
  margin: 40px 40px 50px 40px
  .data-table
    >>> .el-icon-star-on
      font-size: 20px
      color: #bbbbbb
    .selected
      color: red
</style>